import axios from "axios";
import store from "~/store";
import i18n from "~/plugins/i18n";
import { createApp } from "vue"; // Import createApp
import { AlertPlugin } from "~/plugins/AlertPlugin";
import { clearServerErrors, showFieldErrors } from "~/plugins/formErrors";

export const TYPE = Object.freeze({
  SUGAR: 2,
});
// Request interceptor
axios.interceptors.request.use(
  async (request) =>
  {

    switch (request.type)
    {
      case null: // default
      case undefined:
        const token = store.getters["auth/token"];
        if (token && !request.azure)
        {
          request.headers.Authorization = `Bearer ${token}`;
        }
        break;
      case TYPE.SUGAR:
        {
          const token = store.getters["auth/token"];
          if (token)
          {
            request.headers.Authorization = `Bearer ${token}`;
          }

          if (window.config.features.sugarCrm)
          {
            if (!store.getters["auth/sugar_access_token"])
            {
              await store.dispatch("auth/sugarConnection");
            }
          }
        }
    }
    // A new save attempt starts with a clean slate of inline server errors.
    if (request.method && request.method.toLowerCase() !== "get")
    {
      clearServerErrors();
    }

    const locale = store.getters["lang/locale"];
    if (locale)
    {
      request.headers["Accept-Language"] = locale;
    }

    // request.headers['X-Socket-Id'] = Echo.socketId()


    return request;

  }, (error) =>
{
  return Promise.reject(error);
});

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  async (error) =>
  {
    const status = error.response?.status;
    const originalRequest = error.config ?? error.request;

    const app = createApp({});
    app.use(AlertPlugin).use(i18n);
    // Only user-triggered saves get the generic alerts below; background GETs stay silent as before.
    const isMutation = !!originalRequest?.method && originalRequest.method.toLowerCase() !== "get";

    if (!status)
    {
      console.error("Network or CORS error:", error);
      if (isMutation && !axios.isCancel(error))
      {
        app.config.globalProperties.$showAlert({
          icon: "error",
          title: "error_alert_title",
          html: i18n.global.t("error_network"),
        });
      }
      throw error;
    }
    if (status >= 500)
    {
      let errors = error.response.data?.errors;
      let errors_arr = [];
      if (errors && typeof errors === "object")
      {
        for (let field of Object.keys(errors))
        {
          errors_arr.push(errors[field][0]);
        }
      }
      else
      {
        errors_arr.push(error.response.data?.message || i18n.global.t("error_alert_title"));
      }
      app.config.globalProperties.$showAlert({
        icon: "error",
        title: "error_alert_title",
        html: errors_arr.join("<br />"),
      });
    }

    if (status === 422)
    {
      const errors = error.response.data?.errors;
      if (errors && typeof errors === "object")
      {
        await showFieldErrors(errors);
      }
      else
      {
        app.config.globalProperties.$showAlert({
          icon: "error",
          title: "error_alert_title",
          html: error.response.data?.message || i18n.global.t("error_alert_title"),
        });
      }
    }

    // Other client errors on saves (403, 409, 419, 429, ...) used to fail silently.
    // 400 and 404 are left to the callers that handle them (booking/add*, ReportRuns).
    if (isMutation && status >= 400 && status < 500 && ![400, 401, 404, 422].includes(status))
    {
      app.config.globalProperties.$showAlert({
        icon: "error",
        title: "error_alert_title",
        html: error.response.data?.message || i18n.global.t("error_request_failed", { status }),
      });
    }

    if ((status === 401) && store.getters["auth/check"] && originalRequest?.type !== TYPE.SUGAR)
    {
      app.config.globalProperties.$showAlert({
        icon: "warning",
        title: "token_expired_alert_title",
        html: i18n.global.t("token_expired_alert_text"),
      });
    }

    return Promise.reject(error);
  }
);
